let signatureUrl = '/Book/Index/wechat';
let scriptElement = null;
let scriptSource = 'http://res.wx.qq.com/open/js/jweixin-1.0.0.js';

let configure = (sign, apiList) => {
    window.wx.config({
        debug: false,
        appId: sign.appId,
        timestamp: sign.timestamp,
        nonceStr: sign.nonceStr,
        signature: sign.signature,
        jsApiList: apiList
    });
};

export default {
    methods: {
        /**
         * 调用微信。
         * 
         * @param {*} apiList 
         */
        wxCall(apiList) {
            return new Promise((resolve, reject) => {
                this.ajaxPost(signatureUrl, {
                    url: window.location.href,
                }).then(response => {
                    if (scriptElement) {
                        configure(response.data.sign, apiList);
                        window.wx.ready(() => {
                            resolve(response);
                        });
                    } else {
                        this.importScript(scriptSource).then(element => {
                            scriptElement = element;
                            configure(response.data.sign, apiList);
                            window.wx.ready(() => {
                                resolve(response);
                            });
                        });
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};